import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { useHistory } from 'react-router-dom';

// COMPONENTS
import Button from '../../components/Button';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as AlertIcon } from '../../assets/svg/alert.svg';

// TYPES
import { OrganisationListOrganisation, OrganisationActivateCommand } from '../../api/models';
import { closeModalType } from '../../components/GlobalModal';

interface ActivateModalTypes {
	organisationDetail?: OrganisationListOrganisation;
	getCompaniesData: () => Promise<void>;
	setActiveTab: React.Dispatch<React.SetStateAction<string>>;
	closeModal?: closeModalType;
}

const ActivateModal: React.FC<ActivateModalTypes> = ({
	closeModal,
	organisationDetail,
	getCompaniesData,
	setActiveTab
}) => {
	const history = useHistory();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const confirmActivate = async () => {
		setIsLoading(true);

		const data: OrganisationActivateCommand = { id: organisationDetail?.id };

		const response = await apibridge.postOrganisationActivate(data);

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			if (closeModal) {
				closeModal();
			}

			await getCompaniesData();

			setActiveTab('active');

			setIsLoading(false);
		}
	};

	return (
		<div className="modal-confirmation">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<figure className="icon">
									<AlertIcon />
								</figure>

								<h2 className="heading h4">
									Are you sure you wish to Activate <strong> '{organisationDetail?.name}'?</strong>
								</h2>

								<section className="actions">
									<Button className="btn-primary full-width" onClick={confirmActivate}>
										Yes
									</Button>

									<Button className="btn-secondary full-width" onClick={closeModal}>
										Cancel
									</Button>
								</section>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default ActivateModal;
